<template>
  <div class="footer">
    <div class="footer-1">
      <div class="info footerInfo flexBetween">
        <div class="footerLeft">
          <div class="footer-nav">
            <ul class="flex">
              <li><router-link to="../home">首页</router-link></li>
              <li><router-link to="../about">关于我们</router-link></li>
              <li><router-link to="../brief">产品中心</router-link></li>
              <li><router-link to="../news">资讯中心</router-link></li>
              <li><router-link to="../contact">联系我们</router-link></li>
            </ul>
          </div>
          <div class="footer-text">
            <p>联系电话：</p>
            <p>020-31700169</p>
            <p>地址：广州市黄埔区港湾路68号2016</p>
          </div>
        </div>
        <div class="footerRight flex">
          <div class="footerEwm">
            <img src="../../static/img/ewm-hz.png" alt="" width="118" />
            <p>货主端</p>
          </div>
          <div class="footerEwm">
            <img src="../../static/img/ewm-cd.png" alt="" width="118" />
            <p>船东端</p>
          </div>
          <div class="footerEwm">
            <img src="../../static/img/theNo.jpg" alt="" width="118" />
            <p>公众号</p>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-2">
      <div class="info">
        <p>
          广东货多多物流科技股份有限公司 版权所有 |
          增值电信业务经营许可证：粤B2-20190474 |
          <a
            v-if="isOneTwo"
            style="color: #1f7ffa"
            href="https://beian.miit.gov.cn/"
            target="_blank"
            >粤ICP备18111920号-1</a
          >
          <a
            v-else
            style="color: #f02427"
            href="https://beian.miit.gov.cn/"
            target="_blank"
            >粤ICP备18111920号-2</a
          >
          <span class="img-box"
            >营业执照
            <el-image
              v-for="(item, index) in businessList"
              :key="index"
              style="width: 20px; height: 20px;margin-right:10px;vertical-align: middle;"
              :src="item"
              :preview-src-list="srcList">
            </el-image>
          </span>
        </p>
        <p class="info_buttom">
<!--          <span
            ><a
              href="https://hyjhapp.oss-cn-shenzhen.aliyuncs.com/11/%E9%85%8D%E5%90%88%E7%9B%91%E7%AE%A1%E9%83%A8%E9%97%A8%E4%BE%9D%E6%B3%95%E8%B0%83%E5%8F%96%E6%9F%A5%E8%AF%A2%E6%95%B0%E6%8D%AE%E6%89%BF%E8%AF%BA%E4%B9%A6.pdf"
              target="_blank"
              >《配合监管部门依法调取查询数据承诺书》</a
            ></span
          >-->
          <span>
            <a
              href="https://platformfile.oss-cn-shenzhen.aliyuncs.com/common/certificate/%E6%B1%BD%E8%BF%90%E4%BF%A1%E6%81%AF%E7%B3%BB%E7%BB%9F%E5%AE%89%E5%85%A8%E7%AD%89%E7%BA%A7%E4%BF%9D%E6%8A%A4%E5%A4%87%E6%A1%88%E8%AF%81%E6%98%8E.jpg"
              target="_blank"
              >《等保备案证明汽运版》</a
            ></span
          >
          <span
            ><a
              href="https://platformfile.oss-cn-shenzhen.aliyuncs.com/common/certificate/%E6%B0%B4%E8%BF%90%E4%BF%A1%E6%81%AF%E7%B3%BB%E7%BB%9F%E5%AE%89%E5%85%A8%E7%AD%89%E7%BA%A7%E4%BF%9D%E6%8A%A4%E5%A4%87%E6%A1%88%E8%AF%81%E6%98%8E.jpg"
              target="_blank"
              >《等保备案证明水运版》</a
            ></span
          >
          <span
            ><a
              href="https://ship.huoyunjh.com/#/qualificationAndRule/0"
              target="_blank"
              >资质与规则</a
            ></span
          >
        </p>
      </div>
    </div>
    <div class="phone-footer">广东货多多物流科技股份有限公司 版权所有</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isOneTwo: true,
      businessList: [
        'https://platformfile.oss-cn-shenzhen.aliyuncs.com/common/certificate/%E6%80%BB%E5%85%AC%E5%8F%B8%E8%90%A5%E4%B8%9A%E6%89%A7%E7%85%A7.jpg',
        'https://platformfile.oss-cn-shenzhen.aliyuncs.com/common/certificate/%E6%8A%9A%E5%B7%9E%E5%88%86%E5%85%AC%E5%8F%B8%E8%90%A5%E4%B8%9A%E6%89%A7%E7%85%A7.jpg',
        // '../../static/img/businessIicense3.jpg',
        'https://platformfile.oss-cn-shenzhen.aliyuncs.com/common/certificate/%E4%BE%9B%E5%BA%94%E9%93%BE%E5%85%AC%E5%8F%B8%E8%90%A5%E4%B8%9A%E6%89%A7%E8%A1%8C%E7%85%A7%E6%AD%A3%E9%9D%A2.jpg'
      ],
      srcList: [
        'https://platformfile.oss-cn-shenzhen.aliyuncs.com/common/certificate/%E6%80%BB%E5%85%AC%E5%8F%B8%E8%90%A5%E4%B8%9A%E6%89%A7%E7%85%A7.jpg',
        'https://platformfile.oss-cn-shenzhen.aliyuncs.com/common/certificate/%E6%8A%9A%E5%B7%9E%E5%88%86%E5%85%AC%E5%8F%B8%E8%90%A5%E4%B8%9A%E6%89%A7%E7%85%A7.jpg',
        // 'https://platformfile.oss-cn-shenzhen.aliyuncs.com/common/certificate/%E6%B1%9F%E8%A5%BF%E5%88%86%E5%85%AC%E5%8F%B8%E8%90%A5%E4%B8%9A%E6%89%A7%E7%85%A7.jpg',
        'https://platformfile.oss-cn-shenzhen.aliyuncs.com/common/certificate/%E4%BE%9B%E5%BA%94%E9%93%BE%E5%85%AC%E5%8F%B8%E8%90%A5%E4%B8%9A%E6%89%A7%E8%A1%8C%E7%85%A7%E6%AD%A3%E9%9D%A2.jpg'

      ]
    };
  },
  mounted() {
    let href = window.location.href;
    if (href.indexOf("gd-hdd") !== -1) {
      this.isOneTwo = false;
    } else {
      this.isOneTwo = true;
    }
  },
};
</script>
<style scoped="scoped">
a {
  cursor: pointer;
}
.footer {
  width: 100%;
  height: auto;
  background-color: #232526;
  letter-spacing: 2px;
}
.footerInfo {
  padding: 80px 0px 100px;
}
.footer-nav ul li {
  margin-right: 116px;
}
.footer-nav ul li a {
  color: #fff;
  transition: 0.3s;
}
.footer-nav ul li a:hover {
  color: #127bfd;
}
.footer-text {
  margin-top: 100px;
}
.footer-text p:nth-of-type(1) {
  color: #fff;
}
.footer-text p:nth-of-type(2) {
  color: #127bfd;
  font-size: 40px;
  font-weight: bold;
}
.footer-text p:nth-of-type(3) {
  color: #fff;
  margin-top: 40px;
}
.footerRight {
  justify-content: flex-end;
}
.footerEwm {
  margin-left: 30px;
  text-align: center;
}
.footerEwm p {
  color: #fff;
  margin-top: 15px;
}
.footer-2 {
  border-top: 1px solid #838789;
}
.footer-2 p {
  line-height: 23px;
  padding-top: 10px;
  color: #ffffff;
  text-align: center;
  font-size: 14px;
}
.info_buttom {
  height: 30px;
  line-height: 30px;
}
.info_buttom span a {
  color: #1f7ffa;
}
.info_buttom_most {
  height: 30px;
  line-height: 30px;
  color: #1f7ffa;
}
.info_buttom_most span a {
  color: #1f7ffa;
}
.img3{
   width: 600px;
  height: 980px;
  /* transform: rotate(-90deg) translate(43%, 17%); */
}
@media only screen and (max-width: 1600px) {
  .footerInfo {
    padding: 80px 30px 100px;
  }
  .footer-nav ul li {
    margin-right: 54px;
  }
}

@media only screen and (max-width: 750px) {
  .footer-1,
  .footer-2 {
    display: none;
  }
  /* .footer{
		position: absolute;
		bottom: 0;
	} */
  .phone-footer {
    width: 100%;
    height: auto;
    line-height: 36px;
    text-align: center;
    font-size: 10px;
    color: rgba(255, 255, 255, 0.8);
  }
}
.business {
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/myFooter.vue